<template>
    <div class="aipage">
        <div class="banner-img background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_banner.png')})`}">
            <div class="banner">
                <div class="banner-title background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_title2.png')})`}"></div>
                <div class="banner-smallTitle">从基建到运营，为央国企提供AI算力中心全生命周期建运服务，构建高效能、高安全、高智能的一站式数字化算力底座</div>
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_bg1.png')})`}">
            <div class="aipage_content" style="width: 11.4rem;">
                <p class="titleBlue" >算力中心建设</p>
                <div class="flex-between">
                    <div class="content-item" v-for="item in aiContentList" :key="item.index">
                        <div class="background content-item-titleBg" :style="{ 'backgroundImage' : `url(${item.titlePic})`}" >
                            <span class="content-item-title">{{ item.title }}</span>
                        </div>
                        <div class="background content-item-wrapBg" :style="{ 'backgroundImage' : `url(${item.wrapPic})`}" >
                            <span class="content-item-label">{{ item.content }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_bg2.png')})`, height:'4rem' }">
            <div class="aipage_content">
                 <p class="titleBlue" style="color: #fff;">央国企专属服务</p>
                 <div class="background serviceWrap" v-for="item in serviceList" :key="item.index">
                        <div class="service-item-title">{{ item.title }}</div>
                        <div class="service-item-text">{{ item.subTitle }}</div>
                 </div> 
            </div>
        </div>

        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_bg3.png')})`}">
            <div class="aipage_content" >
                <p class="titleBlue" >托管与运营</p>
                <div class="flex-between">
                    <div class="operation-item background" v-for="item in operationList" :key="item.index" :style="{ 'backgroundImage' : `url(${item.wrapPic})`}">
                        <div class="operation-item-label">
                            <div>{{  item.title }}</div>
                            <div class="operation-item-content">{{  item.content }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_bg4.png')})`, height:'4.6rem' }">
            <div class="aipage_content" >
                 <p class="titleBlue">服务优势</p>
                 <div style="display: flex; justify-content: center;">
                    <div class="advantage-wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_wrapbg8.png')})`}">
                        <div v-for="item in advantageList" :key="item.key" class="advantage-item">
                            <div class="advantage-item-title">{{ item.title }}</div>
                            <div class="advantage-item-content">{{ item.subTitle }}</div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>

        <div class="aipage_wrap background" :style="{ 'backgroundImage' : `url(${require('@/assets/images/bussiness/maas/co_bg5.png')})`}">
            <div class="aipage_content" >
                <p class="titleBlue">成功案例</p>
                <div class="flex-between">
                    <div class="case-item" v-for="item in caseList" :key="item.index">
                        <div class="case-item-img background" :style="{ 'backgroundImage' : `url(${item.wrapPic})`}"></div>
                        <div class="case-item-label">
                            <div>{{  item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
export default {
    data() {
        return {
            aiContentList: [
                { title: '咨询', titlePic: require("@/assets/images/bussiness/maas/co_tittlebg1.png"), content: '需求分析与可行性评估', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg1.png") },
                { title: '规划', titlePic: require("@/assets/images/bussiness/maas/co_tittlebg2.png"), content: '算力规模与架构设计', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg2.png") },
                { title: '设计', titlePic: require("@/assets/images/bussiness/maas/co_tittlebg3.png"), content: '硬件选型与安全方案定制', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg3.png") },
                { title: '实施', titlePic: require("@/assets/images/bussiness/maas/co_tittlebg4.png"), content: '部署调试与系统集成', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg4.png") },
            ],
            serviceList: [
                { title: '合规性适配', subTitle: '满足等保2.0/国资云标准' },
                { title: '定制开发', subTitle: '与现有业务系统无缝对接' },
                { title: '专属团队', subTitle: '技术专家+国资服务经验顾问' },
            ],
            operationList: [
                { title: '资源变现策略', content: '数据资产化运营、模型服务超市', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg5.png") },
                { title: '成本控制创新', content: '能效管理、闲置资源复用', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg6.png") },
                { title: '运维托管', content: '经验工程师驻场、知识转移', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg7.png") },
            ],
            advantageList: [
                { title: '技术领先性', subTitle: '搭载自主可控的异构算力调度系统（英伟达、寒武纪、海光）,支持千卡级集群训练任务无间断运行,性能指标达行业领先水平；集群PUE≤1.15' },
                { title: '一站式服务', subTitle: '提供从顶层设计、设备选型到持续运营的全包服务' },
                { title: '经验壁垒', subTitle: '累计交付5家国家级智算中心项目，沉淀形成覆盖申报、建设、运营的全周期方法论库' },
                { title: '安全体系', subTitle: '通过等保三级、商用密码应用安全性评估等认证，构建从芯片到应用的多层防护体系' },
            ],
            caseList: [
                { title: '南京智能计算中心', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg9.png") },
                { title: '青海移动高原大数据中心', wrapPic: require("@/assets/images/bussiness/maas/co_wrapbg10.png") },
            ]
        }
    },

    mounted() {
        // 页面加载时回到顶部
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        
        // 初始化检测可见元素
        this.checkVisibility();
        
        // 监听滚动事件（使用节流优化性能）
        this.scrollHandler = this.throttle(() => {
            this.checkVisibility();
        }, 100); // 100ms触发一次，平衡性能与灵敏度
        window.addEventListener('scroll', this.scrollHandler);
    },

    beforeDestroy() {
        // 移除滚动监听，避免内存泄漏
        window.removeEventListener('scroll', this.scrollHandler);
    },

    methods: {
        // 节流函数：限制事件触发频率
        throttle(fn, delay) {
            let lastTime = 0;
            return function(...args) {
                const now = Date.now();
                if (now - lastTime > delay) {
                lastTime = now;
                fn.apply(this, args);
                }
            };
        },

        // 检测元素是否进入视图范围
        isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            // 元素顶部进入视图底部80%位置时判定为可见（优化触发时机）
            return rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8;
        },

        // 检查所有动画元素的可见性
        checkVisibility() {
            const animatedElements = document.querySelectorAll(
                '.content-item, .serviceWrap, .operation-item, .advantage-item, .case-item'
            );
            
            animatedElements.forEach(el => {
                if (this.isElementInViewport(el) && !el.classList.contains('visible')) {
                    el.classList.add('visible');
                }
            });
        }
    }
}
</script>


<style lang="scss" scoped>
// 入场动画关键帧定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.banner {
  left: 20%;
  top: 1.4rem;
  animation: fadeIn 0.8s ease-out forwards; /*  banner区域入场动画 */
  opacity: 0;
  &-title {
    width: 4.7rem;
    height: 1.4rem;
    background-size: contain;
  }
  &-smallTitle {
    color: #fff;
    width: 6.8rem;
    letter-spacing: 2px;
    line-height: 0.24rem;
    font-size: 0.14rem;
    animation-delay: 0.3s; /* 标题文字延迟出现 */
    opacity: 0;
    animation: fadeInUp 0.8s ease-out forwards;
  }
}

.background {
  background-position: center;
  background-repeat: no-repeat;
}

.banner-img {
  width: 100%;
  height: 2.8rem;
  position: relative;
  background-size: cover;
}

.titleBlue {
  font-size: 0.3rem;
  color: #0061e3;
  font-weight: 600;
  letter-spacing: 0.05rem;
  text-align: center;
  height: 0.6rem;
  margin: 0.2rem 0;
  font-family: '黑体';
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  animation-delay: 0.2s;
}

// 为各区块内容添加入场动画（通过滚动触发，配合visibility控制）
.content-item {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden; /* 初始隐藏 */
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
}
.content-item.visible { visibility: visible; } /* 滚动到视图时显示 */

.content-item-titleBg {
  width: 0.8rem;
  height: 0.68rem;
  color: #0061e3;
  font-size: 0.17rem;
  font-weight: 600;
  text-align: center;
  background-size: contain;
  position: relative;
}

.content-item-title {
  position: absolute;
  bottom: -0.05rem;
  left: 0.28rem;
}

.content-item-wrapBg {
  width: 2.7rem;
  height: 1.5rem;
  background-size: contain;
  margin-top: 0.12rem;
  margin-bottom: 0.5rem;
}

.content-item-label {
  font-size: 0.16rem;
  color: #333;
  font-weight: 600;
  margin-left: 0.28rem;
  position: relative;
  top: 0.5rem;
}

.serviceWrap {
  background-image: url('../../assets/images/bussiness/maas/co_bar1.png');
  width: 10rem;
  height: 0.8rem;
  position: relative;
  margin-top: 0.2rem;
  background-size: contain;
  padding-top: 0.05rem;
  left: 1rem;
  transition: all 0.3s ease;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden;
  &:nth-of-type(1) { animation-delay: 0.1s; }
  &:nth-of-type(2) { animation-delay: 0.2s; left: 1.86rem; }
  &:nth-of-type(3) { animation-delay: 0.3s; left: 2.74rem; }
}
.serviceWrap.visible { visibility: visible; }

.service-item-title {
  color: #f3f4f5;
  font-size: 0.16rem;
  position: relative;
  left: 6.9rem;
  top: 0.1rem;
  width: 1rem;
}

.service-item-text {
  color: #f7f8f9;
  font-size: 0.15rem;
  position: relative;
  left: 6.9rem;
  top: 0.13rem;
  width: 2rem;
}

.operation-item {
  width: 3.4rem;
  height: 3rem;
  margin-bottom: 0.3rem;
  position: relative;
  background-size: contain;
  transition: all 0.3s ease;
  cursor: pointer;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden;
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
}
.operation-item.visible { visibility: visible; }

.operation-item-label {
  position: relative;
  top: 2rem;
  left: 0.2rem;
  width: 2.8rem;
  height: 0.2rem;
  font-size: 0.2rem;
  color: #0061e3;
  font-weight: 600;
}

.operation-item-content {
  font-size: 0.16rem;
  color: #363836;
  margin-top: 0.1rem;
}

.advantage-wrap {
  width: 11rem;
  height: 3.4rem;
  background-size: contain;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.advantage-item {
  position: relative;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden;
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.3s; }
  &:nth-child(4) { animation-delay: 0.4s; }
}
.advantage-item.visible { visibility: visible; }

.advantage-item-title {
  font-size: 0.16rem;
  color: #1192ff;
  font-weight: 600;
  position: relative;
  top: 0.32rem;
}

.advantage-item:nth-of-type(odd) .advantage-item-title {
  text-align: right;
}

.advantage-item:nth-of-type(even) .advantage-item-title {
  text-align: left;
}

.advantage-item-content {
  font-size: 0.14rem;
  color: #f1f2f3;
  width: 4.5rem;
  position: relative;
  padding-top: 0.5rem;
}

.case-item {
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  animation: fadeInUp 0.6s ease-out forwards;
  visibility: hidden;
  &:nth-child(1) { animation-delay: 0.1s; }
  &:nth-child(2) { animation-delay: 0.2s; }
}
.case-item.visible { visibility: visible; }

.case-item-img {
  width: 5.4rem;
  height: 3rem;
  transition: all 0.3s ease;
}

.case-item-label {
  width: 100%;
  background: #fff;
  padding: 0.24rem 0;
  font-size: 0.2rem;
  color: #333;
  font-weight: 600;
  text-indent: 0.2rem;
  border-bottom-right-radius: 0.04rem;
  border-bottom-left-radius: 0.04rem;
  transition: all 0.3s ease;
  margin-bottom:0.5rem;
}

// 悬停动画效果
.content-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 97, 227, 0.1);
}

.serviceWrap:hover {
  transform: scale(1.02);
  filter: brightness(1.1);
}

.operation-item:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 16px rgba(0, 97, 227, 0.15);
}

.case-item:hover .case-item-img {
  transform: scale(1.05);
}

.case-item:hover .case-item-label {
  background-color: #0061e3;
  color: #fff;
}
@media screen and (min-width: 2000px) {
    .banner {
      &-smallTitle {
        font-size: 0.12rem;
      }
      &-title {
        width: 4.2rem;
        height: 1.2rem;
      }
    }
    
    .titleBlue {
      font-size: 0.26rem;
    }
    .content-item-titleBg {
      width: 0.72rem;
      height: 0.6rem;
      font-size: 0.15rem;
    }

    .content-item-label {
      font-size: 0.14rem;
    }
    .service-item-title {
      font-size: 0.15rem;
    }

    .service-item-text {
      font-size: 0.14rem;
    }
    .operation-item-label {
      font-size: 0.18rem;
    }

    .operation-item-content {
      font-size: 0.14rem;
    }
    .advantage-item-title {
      font-size: 0.15rem;
    }
    .advantage-item-content {
      font-size: 0.12rem;
    }
    .case-item-label {
      font-size: 0.16rem;
    }
}
</style>


<style lang="scss">
.aipage {
  .el-button--small {
    padding: 0.1rem 0.4rem;
    border-color: #0061e3;
    color: #0061e3;
    font-weight: 600;
    border-radius: 0;
    transition: all 0.3s ease;
  }
  .el-button--small:hover {
    background-color: #0061e3;
    color: #fff;
    transform: translateY(-2px);
  }
}

.aipage_wrap {
  width: calc(100% - 0.48rem);
  display: flex;
  justify-content: center;
  padding: 0.24rem;
  background-color: #f5f5f5;
}

.aipage_content {
  width: 12rem;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.flex-wrap {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.dot-w {
  display: inline-block;
  width: 0.08rem;
  height: 0.08rem;
  background-color: #fff;
  border-radius: 50%;
}

.el-divider--horizontal {
  margin: 0.16rem 0;
}

</style>